import React from 'react';
import { Navigation } from './components/Navigation';
import { Hero } from './components/Hero';
import { TrustBadges } from './components/TrustBadges';
import { BrandsSection } from './components/BrandsSection';
import { ProductsSection } from './components/ProductsSection';
import { WhySection } from './components/WhySection';
import { SocialProofSection } from './components/SocialProofSection';
import { ManufacturerPartnerSection } from './components/ManufacturerPartnerSection';
import { TerritoriesSection } from './components/TerritoriesSection';
import { FAQSection } from './components/FAQSection';
import { AboutSection } from './components/AboutSection';
import { ContactForm } from './components/ContactForm';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-[#F6F8FB] text-[#0B1220]" style={{
    fontFamily: 'Inter, sans-serif'
  }} data-id="element-0">
      <Navigation data-id="element-1" />
      <Hero data-id="element-2" />
      <TrustBadges data-id="element-3" />
      <BrandsSection data-id="element-4" />
      <ProductsSection data-id="element-5" />
      <WhySection data-id="element-6" />
      <SocialProofSection data-id="element-7" />
      <ManufacturerPartnerSection data-id="element-8" />
      <TerritoriesSection data-id="element-9" />
      <FAQSection data-id="element-10" />
      <AboutSection data-id="element-11" />
      <ContactForm data-id="element-12" />
      <Footer data-id="element-13" />
    </div>;
}